// extracted by extract-css-chunks-webpack-plugin
module.exports = {"batch-list-tabs":"batch-list__batch-list-tabs___ktADS","batchListTabs":"batch-list__batch-list-tabs___ktADS","tab":"batch-list__tab___1MzOS","tab-content":"batch-list__tab-content___2a7tv","tabContent":"batch-list__tab-content___2a7tv"};
    if(module.hot) {
      // 1754451911897
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  